import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  providers: [provideTranslocoScope('products')],
  selector: 'prd-clear-cart-dialog',
  imports: [TranslocoPipe,
    MatDialogModule,
    MatButtonModule,
  ],
  templateUrl: './clear-cart-dialog.html',
  styleUrl: './clear-cart-dialog.scss',
})
export class ClearCartDialog {
  constructor(private dialogRef: MatDialogRef<ClearCartDialog, boolean>) {}

  onCancel() {
    this.dialogRef.close(false);
  }

  onConfirm() {
    this.dialogRef.close(true);
  }
}
